import {connect} from 'react-redux';
import LoanMigrationView from '../components/views/LoanMigrationView';
import * as POSDataStepActions from '../actions/POSDataStepActions';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import {Group} from '../types/types';
import {LoanMigrationDispatchProps, LoanMigrationStateProps} from '../types/containers';
import {mapStateToToken} from '../utils/LoanCommonDataMappers';

const mapStateToProps = (state: State, ownProps): LoanMigrationStateProps => {
    const {group} = state.commonLoanApplication.pos.posData;
    const token = mapStateToToken(state);
    const newGroup: Group = ownProps.data.newGroup ? ownProps.data.newGroup : {};
    const isSuccess = (ownProps.data && ownProps.data.isSuccess) ? ownProps.data.isSuccess : false;
    return {
        isSuccess,
        token,
        originGroup: group,
        targetGroup: newGroup,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): LoanMigrationDispatchProps => {
    return {
        onPressMigrationConfirm: (newGroup: Group) => {
            dispatch(POSDataStepActions.MIGRATE_POS_REQUEST_ACTION.action(newGroup));
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const GroupMigrationContainer = connect(
    mapStateToProps, mapDispatchToProps
)(LoanMigrationView);

export default GroupMigrationContainer;